module.exports = __webpack_public_path__ + "static/media/Getty_Images_1145406500_desktop.395f3083.jpg";